import cropApi from '@/api/cropApi';
import attributeApi from '@/api/attributeApi';

export default  {
    namespaced: true,
    state: {
        defaultCropLength: 0,
        attributeEnum: null,
        locations: [],
        productTypes: [],
        financialYears: [],
        productVarieties: [],
        attributes: []
    },
    getters: {
        getAttributeEnum(state) {
            return state.attributeEnum;
        },
        getLocations(state) {
            return state.locations;
        },
        getProductTypes(state) {
            return state.productTypes;
        },
        getFinancialYears(state) {
            return state.financialYears;
        },
        getProductVarieties(state) {
            return (productTypeID) => {
                return state.productVarieties.filter(pv => pv.ProductTypeID === productTypeID);
            }
        },
        getAttributes(state) {
            return (productTypeID) => {
                let productType = state.productTypes.find(pt => pt.ProductTypeID == productTypeID);
                if (productType != null) {
                    return state.attributes.filter(a => a.IsActive && (a.ProductCategories.length === 0 || a.ProductCategories.some(pc => pc == productType.ProductCategoryID)));
                }

                return [];
            }
        },
        getAttributeValues(state) {
            return (attributeID) => {
                return state.attributes.find(a => a.AttributeID === attributeID).AttributeValues.filter(av => av.IsActive);
            }
        }
    },
    mutations: {
        updateAttributeEnum(state, attributeEnum) {
            state.attributeEnum = attributeEnum;
        },
        updateLocations(state, locations) {
            state.locations = locations;
        },
        updateProductTypes(state, productTypes) {
            state.productTypes = productTypes;
        },
        updateFinancialYears(state, financialYears) {
            state.financialYears = financialYears;
        },
        updateDefaultCropLength(state, defaultCropLength) {
            state.defaultCropLength = defaultCropLength;
        },
        updateProductVarieties(state, productVarieties) {
            state.productVarieties = productVarieties;
        },
        updateAttributes(state, attributes) {
            state.attributes = attributes;
        }
    },
    actions : {
        async loadLookups({ commit }, plantID) {
            let details = await cropApi.getLookups(plantID);
            let attributes = await attributeApi.getAttributes();

            commit('updateAttributeEnum', details.AttributeEnum);
            commit('updateLocations', details.Locations);
            commit('updateProductTypes', details.ProductTypes);
            commit('updateProductVarieties', details.ProductVarieties);
            commit('updateFinancialYears', details.FinancialYears);
            commit('updateDefaultCropLength', details.DefaultCropLength);

            commit('updateAttributes', attributes);
        }
    }
}